<template>
  <div>
    <div
      class="inquirylist"
      v-for="item in inquirylist"
      :key="item.id"
      :style="[item.style]"
    >
      <span v-if="!item.specific">
        {{formatter(item)}}
      </span>
      <div
        v-else
        class="specific"
      >
        <span>{{scope.row[item.bind[0]]}}</span>
        <span>发送至</span>
        <span>{{scope.row[item.bind[1]]}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Object,
    scope: Object
  },
  computed: {
    inquirylist() {
      let that = this;
      return this.tableData.datalist(this.scope.row).filter(item => {
        return (
          that.scope.row[item.bind] || (typeof item.bind === "object" && item.bind.some(item => that.scope.row[item]))
        );
      });
    }
  },
  data() {
    return {};
  },
  methods: {
    formatter(item) {
      if (item.formatter) {
        return item.formatter(item, this.scope.row);
      } else {
        return this.scope.row[item.bind] || "";
      }
    }
  },
  components: {}
};
</script>

<style>
.inquirylist {
  min-height: 20px;
  font-size: 14px;
  color: #333;
  line-height: 20px;
  margin: 4px 0;
}
.specific :nth-child(1) {
  color: #3da1ff;
  user-select: none;
}
.specific :nth-child(2) {
  margin: 0 8px;
}
.specific :nth-child(3) {
  color: #3da1ff;
  user-select: none;
}
</style>
